import { lazy } from 'react'

export const LocationVariant1 = lazy(() => import('./LocationVariant1'))
